import type { StorageType } from './props';

const WebStorage: StorageType = {
    async getItem(key: string): Promise<string | null> {
        let result = null as string | null;

        if (localStorage) {
            result = localStorage.getItem(key);
        }

        return result;
    },

    async setItem(key: string, value: string): Promise<void> {
        if (localStorage) {
            localStorage.setItem(key, value);
        }
    },

    async removeItem(key: string): Promise<void> {
        if (localStorage) {
            localStorage.removeItem(key);
        }
    },

    async getParsedItem(key) {
        const value = await this.getItem(key);

        return value && JSON.parse(value);
    },
};

export default WebStorage;
